import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminCustomPages = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CUSTOM_PAGES.GET_ALL, { params });
    return response.data;
};

export const getAdminCustomPageById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CUSTOM_PAGES.GET_BY_ID(id));
    return response.data;
};

export const createCustomPage = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.CUSTOM_PAGES.CREATE, data);
    return response.data;
};

export const updateCustomPage = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.CUSTOM_PAGES.UPDATE(id), data);
    return response.data;
};

export const deleteCustomPage = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.CUSTOM_PAGES.DELETE(id));
    return response.data;
};
